module.exports = __webpack_public_path__ + "img/walletconnect-logo.d1f73612.svg";